import EnvironmentModel from "../domain/environmentModel";

export const Environment: EnvironmentModel = {
  HOME_PAGE: "/",
  API_BASE_URL: process.env.REACT_APP_API_BASE_URL ?? "",
  APP_ENVIRONMENT: process.env.REACT_APP_ENVIRONMENT ?? "unknown",
};
